<div class="app-direction-root" [dir]="direction">
    <router-outlet></router-outlet>
    <app-calls-widget *ngIf="showCallsWidget"></app-calls-widget>
</div>
